import {
    LOG_IN,
    LOG_OUT,
    LOG_OUT_SUCCESS,
    LOG_OUT_FAIL,
    LOG_IN_FAIL,
    CHECK_SESSION,
    CHECK_SESSION_SUCCESS,
    CHECK_SESSION_FAIL,
    LOAD_USER_PROFILE,
    LOAD_USER_PROFILE_SUCCESS,
    LOAD_USER_PROFILE_FAILURE,
    UPDATE_USER_PROFILE,
    UPDATE_USER_PROFILE_SUCCESS,
    UPDATE_USER_PROFILE_FAILURE,
    OPEN_USER_PROFILE_DIALOG,
    CLOSE_USER_PROFILE_DIALOG,
    SHOW_SESSION_WARNING,
    HIDE_SESSION_WARNING,
    EXTEND_SESSION,
    EXTEND_SESSION_FAILURE,
} from './SessionActionTypes'

export const initialSessionState = () => ({
    // User info (fetched from /api/auth/v1/me)
    loggedInUser: null,
    userId: null,
    organizationId: null,
    organizationName: null,
    role: null,

    // UI state
    loggingIn: false,
    loggingOut: false,
    checkingSession: false,
    sessionChecked: false,
    loginErrorMessage: null,
    sessionWarningVisible: false,
    extendingSession: false,

    // User profile
    userProfileModel: {
        userProfile: null,
        isLoading: false,
        errorMessage: null,
        profileDialogOpen: false,
    },
});

const session = (state = initialSessionState(), action) => {
    switch (action.type) {
        case CHECK_SESSION:
            return {
                ...state,
                checkingSession: true,
                sessionChecked: true, // Mark that check has been initiated
            }
        case CHECK_SESSION_SUCCESS:
            return {
                ...state,
                checkingSession: false,
                loggedInUser: action.userInfo.username,
                userId: action.userInfo.userId,
                organizationId: action.userInfo.organizationId,
                organizationName: action.userInfo.organizationName,
                role: action.userInfo.role,
            }
        case CHECK_SESSION_FAIL:
            return {
                ...state,
                checkingSession: false,
                loggedInUser: null,
                userId: null,
                organizationId: null,
                organizationName: null,
                role: null,
            }
        case LOG_IN:
            return {
                ...state,
                loggingIn: true,
                loginErrorMessage: null,
            }
        case LOG_IN_FAIL:
            return {
                ...state,
                loggingIn: false,
                loggedInUser: null,
                loginErrorMessage: 'Inloggning misslyckades, kontrollera uppgifterna och testa igen.',
            }
        case LOG_OUT:
            return {
                ...state,
                loggingOut: true,
                sessionWarningVisible: false,
            }
        case LOG_OUT_FAIL:
            return {
                ...state,
                loggingOut: false,
            }
        case LOG_OUT_SUCCESS:
            return {
                ...initialSessionState(),
            }
        case SHOW_SESSION_WARNING:
            return {
                ...state,
                sessionWarningVisible: true,
            }
        case HIDE_SESSION_WARNING:
            return {
                ...state,
                sessionWarningVisible: false,
                extendingSession: false,
            }
        case EXTEND_SESSION:
            return {
                ...state,
                extendingSession: true,
            }
        case EXTEND_SESSION_FAILURE:
            return {
                ...state,
                extendingSession: false,
            }
        case OPEN_USER_PROFILE_DIALOG:
            return {
                ...state,
                userProfileModel: {
                    ...state.userProfileModel,
                    profileDialogOpen: true,
                    errorMessage: null,
                }
            }
        case CLOSE_USER_PROFILE_DIALOG:
            return {
                ...state,
                userProfileModel: {
                    ...state.userProfileModel,
                    profileDialogOpen: false,
                    errorMessage: null,
                }
            }
        case LOAD_USER_PROFILE:
            return {
                ...state,
                userProfileModel: {
                    ...state.userProfileModel,
                    isLoading: true,
                    errorMessage: null,
                }
            }
        case LOAD_USER_PROFILE_SUCCESS:
            return {
                ...state,
                userProfileModel: {
                    ...state.userProfileModel,
                    userProfile: action.userProfile,
                    isLoading: false,
                    errorMessage: null,
                }
            }
        case LOAD_USER_PROFILE_FAILURE:
            return {
                ...state,
                userProfileModel: {
                    ...state.userProfileModel,
                    isLoading: false,
                    errorMessage: action.message,
                }
            }
        case UPDATE_USER_PROFILE:
            return {
                ...state,
                userProfileModel: {
                    ...state.userProfileModel,
                    isLoading: true,
                    errorMessage: null,
                }
            }
        case UPDATE_USER_PROFILE_SUCCESS:
            return {
                ...state,
                userProfileModel: {
                    ...state.userProfileModel,
                    isLoading: false,
                    errorMessage: null,
                    profileDialogOpen: false,
                }
            }
        case UPDATE_USER_PROFILE_FAILURE:
            return {
                ...state,
                userProfileModel: {
                    ...state.userProfileModel,
                    isLoading: false,
                    errorMessage: action.message,
                }
            }
        default:
            return state;
    }
}

export default session;
